import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './app/App'
import { Provider } from 'react-redux'
import { store } from './app/store'
import { BrowserRouter } from 'react-router-dom'
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: 'GTM-TXDT62D',
}

TagManager.initialize(tagManagerArgs)

// Mobile scrolling fix
const fixMobileScrolling = () => {
  // Prevent any scroll blocking
  document.addEventListener('touchstart', function(e) {
    // Allow default touch behavior
  }, { passive: true });
  
  document.addEventListener('touchmove', function(e) {
    // Allow default touch behavior
  }, { passive: true });
  
  // Ensure body can scroll
  document.body.style.overflow = 'auto';
  document.body.style.webkitOverflowScrolling = 'touch';
  
  // Fix for iOS Safari
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    document.body.style.position = 'relative';
    document.body.style.height = '100%';
    document.body.style.overflow = 'auto';
  }
};

// Apply fixes when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixMobileScrolling);
} else {
  fixMobileScrolling();
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
